import { ICrListItemFragment } from '@src/common/types';
import { ISenderCrListItemFragment } from '@src/modules/viberBusiness/channels/graphql';

export const isISenderCrListItemFragment = (
  fragment: ICrListItemFragment
): fragment is ISenderCrListItemFragment => {
  return (fragment as ISenderCrListItemFragment).senderId !== undefined;
};
